import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Maintenance from './pages/Maintenance';
import VerifyEmail from './pages/VerifyEmail';
import Header from './components/Header';
import { getSiteState, validateMaintenancePassword } from './api/apiServices';

const App: React.FC = () => {
  const [underMaintenance, setUnderMaintenance] = useState(false);
  const [passwordProtection, setPasswordProtection] = useState(false);
  const [maintenanceUnlocked, setMaintenanceUnlocked] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    async function fetchSiteState() {
      try {
        const data = await getSiteState();
        setUnderMaintenance(Boolean(data.underMaintenance));
        setPasswordProtection(Boolean(data.passwordProtection));
      } catch (error) {
        console.error('Failed to fetch site state:', error);
      } finally {
        setLoaded(true);
      }
    }

    fetchSiteState();
  }, []);

  const handleUnlock = () => {
    setMaintenanceUnlocked(true);
  };

  if (!loaded) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (underMaintenance && !maintenanceUnlocked) {
    return (
      <Maintenance
        passwordProtection={passwordProtection}
        onUnlock={handleUnlock}
        onValidatePassword={validateMaintenancePassword}
      />
    );
  }

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
      </Routes>
    </Router>
  );
};

export default App;
